/**
 * @description
 * 
 * 
 * @param {Object} state with state data of menu module
 * @return {Array}  
 */
const menuItems = state => [
    ...state.menues,
]

/**
 * @description
 * 
 * 
 * @param {Object} state with state data of menu module
 * @return {Array}  
 */
const title = state => state.titleTopBar


//
export default{
    menuItems,
    title,
}